// extracted by css-extract-rspack-plugin
export default {"node":"P41vLKHIQP0V0m5B","nodeCurrent":"sha8V0V_UUgmwslZ","handle":"YpuKnVhImwt4eA1w","kindLabel":"yuEMhpcRxQVbhUdU","nameLabel":"mtzxWh0pnr0grUvZ"};